import { render } from "./PageBase.vue?vue&type=template&id=40939c68"
import script from "./PageBase.vue?vue&type=script&lang=js"
export * from "./PageBase.vue?vue&type=script&lang=js"
script.render = render

export default script